<template>
  <div class="grid-container full">
    <div class="grid-x howItWorksBox">
      <div class="small-12 medium-6 padding-left">
        <h2>How it works</h2>
        <p class="standardcase">You choose which applications to make to which clients. You go through the same process as everyone else. There are no "fast tracks" and no back doors. So when you get hired you know it’s purely on merit.</p>
        <p class="standardcase hide-for-small-only">Our standards are high; we're elite - we look for outstanding people - but not elitist - we have people from over 100 universities on our books. We look at every application to Rare in its full social, educational and personal context.</p>

        <div class="grid-x contactButtonCont">
          <div class="small-12 medium-6 cell text-center">
            <rare-standard-button
              class="contactButton smallLinks"
              :tabIndex="60"
              :active="'true'"
              :buttonText="'Apply now'"
              :height="'40px'"
              :fontColor="'#ffffff'"
              :backgroundColor="'#50e3c2'"
              :fontSize="'12px'"
              @clicked="applyNow"
            />
            <rare-standard-button
              class="contactButton largeLinks"
              :tabIndex="60"
              :buttonText="'Apply now'"
              :height="'64px'"
              :width="'282px'"
              :fontSize="'16px'"
              :fontColor="'#ffffff'"
              :backgroundColor="'#50e3c2'"
              @clicked="applyNow"
            />
            <div class="largeLinks candidateExpenseCont text-center" style="margin-top: 20px; ">
              <span tabindex="62" @keypress="openLegalModal('candidate-expenses-policy')" @click="openLegalModal('candidate-expenses-policy')" class="modalLink">CANDIDATE EXPENSES POLICY</span>
            </div>
          </div>
          <div class="small-6 cell largeLinks">
            <rare-standard-button-light
              class="contactButton largeLinks"
              :tabIndex="61"
              :buttonText="'FAQs'"
              :height="'64px'"
              :width="'282px'"
              :fontSize="'16px'"
              @clicked="openLegalModal('faq')"
            />
          </div>

          <div class="small-12 cell smallLinks">
            <div class="grid-x">
              <div class="small-12 cell" style="margin-top: 16px; ">
                <rare-standard-button-light
                  class="contactButton"
                  :tabIndex="61"
                  :active="'true'"
                  :buttonText="'FAQs'"
                  :height="'40px'"
                  :fontSize="'12px'"
                  @clicked="openLegalModal('faq')"
                />
              </div>
              <div class="small-12 cell" style="margin-top: 16px; margin-bottom: 48px; ">
                <span @click="openLegalModal('candidate-expenses-policy')" class="modalLink">CANDIDATE EXPENSES POLICY</span>
              </div>
            </div>
          </div>

        </div>

      </div>
      <div class="small-12 medium-6 howItWorksInfographic">
        &nbsp;
      </div>
    </div>
  </div>
</template>

<script>

import RareStandardButton from '@/components/atoms/RareWebButton';
import RareStandardButtonLight from '@/components/atoms/RareWebButtonLight';

export default {
  name: 'RareCandidatesHowItWorks',
  components: {
    'rare-standard-button': RareStandardButton,
    'rare-standard-button-light': RareStandardButtonLight,
  },
  methods: {
    openLegalModal(location) {
      console.log(location);
      this.$router.push({ path: `/${location}` });
    },
    applyNow() {
      this.$router.push('/candidates/apply-now');
    },
  },
};
</script>

<style lang="scss" scoped>

@import "~@/css/global.scss";


.howItWorksInfographic {
  background-image: url("../../../assets/img/backgrounds/how-it-works.png");
  background-repeat: no-repeat;
  background-position: top right;
  background-size: contain;
}

.full {
  background-color: transparent;
}

h2 {
  color: $main-text;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
}

.modalLink {
  border-bottom: 1px dotted #4a5b68;
  cursor: pointer;
  color: #4a5b68;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 2px;
  text-align: left;
}

.modalLink:hover {
  border-color: transparent;
}

.modalLinkSep {
  display: inline-block;
  margin: 0 10px 0 10px;
}

.candidateExpenseCont {
  max-width: 282px;
}

@media only screen and (max-width: 1120px)  {
  .padding-left {
    padding: 0 3% 0 3%;
  }
}

@media only screen and (min-width: 800px) {
  .largeLinks {
    display: block;
  }

  .smallLinks {
    display: none;
  }
}

@media only screen and (max-width: 800px)  {
  .largeLinks {
    display: none !important;
  }

  .smallLinks {
    display: inline-block;
    text-align: center;
  }


  .howItWorksInfographic {
    min-height: 500px;
  }

  .padding-left {
    padding: 0 3% 0 3%;
  }

  .howItWorksBox {
    margin-top: 28px;
  }

  .contactButtonCont {
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .contactButton {
    display: inline-block;
    margin: auto;
  }

  .howItWorksInfographic {

  }

  h2 {
    font-size: 28px;
    line-height: 1;
    margin: 20px 0 20px 0;
    text-align: center;
  }

  .modalLink {
    display: inline-block !important;
    text-align: center;
  }


}

@media only screen and (min-width: 641px) {

  .howItWorksInfographic {
    min-height: 670px;
  }

  .padding-left {
    padding: 0 0 0 8.6%;
  }

  .howItWorksBox {
    margin-top: -60px;
  }

  .contactButtonCont {
    margin-top: 40px;
  }

  .howItWorksBox {

  }

  .howItWorksInfographic {

  }

  h2 {
    line-height: 1.29;
    margin: 150px 0 0 0;
  }


}

</style>



// WEBPACK FOOTER //
// src/pages/candidates/components/RareCandidatesHowItWorks.vue